import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import TitleContext from "./TitleContext.js";
export default function WithTitle(props) {
    const previous = useContext(TitleContext);
    return (_jsx(TitleContext.Provider, { value: [...[props.title].flat(), ...[previous].flat()], children: props.children }));
}
